// extracted by mini-css-extract-plugin
module.exports = {"content":"Custom_03_content__102o9"};